export default {
  container: {
    width: '100%',
    maxWidth: '442px',
    height: '100%',
    maxHeight: '442px',
    display: 'flex',
    justifyContent: 'center',
    position: 'absolute',
    top: 0,
    left: 0
  },
  icon: {
    margin: ['8px 16px', '8px 16px', '8px 16px', '8px 16px', '16px 32px']
  }
};